export class AuditModel 
{
    UserId: string;
    Message: string;
    PageNumber: number = 1;
    PageSize: number = 10;
    StartDate: string;
    EndDate: string;
}

export class Audit{
    dateFormatted: string;
    message: string;
    userName: string;
    userType: string;
}

export class AuditResponseModel{
    AuditList: Array<Audit> = [];
    TotalPages: number;
}